import $ from 'jquery';
import { isMobile } from './Utils';

class PortalImageTeaserController {
    constructor(elem) {
        this.elem = elem;
        this.teaserID = elem.id;

        this.dragging = false;
        this.autoslide = elem.dataset.autoslide.toBoolean();
        this.autoslideSpeed = Number(elem.dataset.autoslideSpeed);

        this.SLICK_WRAPPER_ID = `#${elem.dataset.wrapper}`;
        this.SLICK_CONTROLS_ID = `#${elem.dataset.controls}`;
        this.IS_RTL = elem.dataset.rtl === undefined ? false : elem.dataset.rtl.toBoolean();

        this.VIDEO_SELECTOR = 'iframe[data-video]';
        this.CAPTIONS_SELECTOR = '.portal-image-teaser-caption';
        this.prepareSlider(elem);
    }

    prepareSlider() {
        const slickWrapperID = this.SLICK_WRAPPER_ID;
        const slickControlsID = this.SLICK_CONTROLS_ID;

        if (!isMobile()) {
            this.AddFadeClasses(this.elem);
            $(slickWrapperID).on('init', () => {
                this.resetFades(this.elem);
                this.doFades(this.elem);
            });
            $(slickWrapperID).on('afterChange', () => {
                this.doFades(this.elem);
                PortalImageTeaserController.PrepareVideo(this.elem);
            });
            $(slickWrapperID).on('swipe', () => {
                this.resetFades(this.elem);
            });
            $(slickWrapperID).on('beforeChange', () => {
                this.resetFades(this.elem);
                const currentSlide = $(slickWrapperID).find('.slick-active');
                this.PauseVideo(currentSlide);
            });
        }

        this.InitSlickSliderWithVideo(slickWrapperID, slickControlsID, this.autoslide, this.autoslideSpeed);
    }

    AddFadeClasses(element) {
        const captions = $(element).find(this.CAPTIONS_SELECTOR).slice(1);
        captions.addClass('fadeInDown');
    }

    fadeInDownReset() {
        if (!this.dragging) {
            $(this.elem).find('.portal-image-teaser-caption.fadeInDown').stop().delay(400)
                .animate({ opacity: 0, top: '-15px' }, { duration: 800, easing: 'easeInCubic' });
        }
        else {
            $(this.elem).find('.portal-image-teaser-caption.fadeInDown').css({ opacity: 0, top: '-15px' });
        }
    }

    fadeInDown() {
        const fades = $(this.elem).find('.slick-active .portal-image-teaser-caption.fadeInDown');
        const delayInterval = 250;
        $.each(fades, (index, value) => {
            $(value).stop().delay(delayInterval + delayInterval * (index + 1))
                .animate({ opacity: 1, top: '0' }, { duration: 800, easing: 'easeOutCubic' });
        });
    }

    doFades() {
        this.fadeInDown(this.teaserID);
    }

    resetFades() {
        this.fadeInDownReset(this.teaserID);
    }

    static PrepareVideo(container) {
        const activeSlide = $(container).find(`.slick-active ${this.VIDEO_SELECTOR}`);
        if (activeSlide.length > 0) {
            const nodeid = activeSlide.attr('data-video');
            const play = activeSlide.attr('data-play') === 'True';
            const mute = activeSlide.attr('data-mute') === 'True';
            if (play) {
                $(container).slick('slickPause');
                window[`playerSlick${nodeid}`].playVideo();
            }
            if (mute) window[`playerSlick${nodeid}`].mute();
        }
    }

    PauseVideo(currentSlide) {
        const video = $(currentSlide).find(this.VIDEO_SELECTOR);
        if (video.length > 0) {
            const nodeid = video.attr('data-video');
            window[`playerSlick${nodeid}`].pauseVideo();
        }
    }

    SetSlickPadding() {
        if (!isMobile()) {
            const teaser = this.elem;
            const teaserHeight = $(teaser).height();
            const textContainers = $(teaser).find('.portal-image-teaser-caption');
            let textContainerHeight = 0;
            let padding = 0;
            $.each(textContainers, (index, value) => {
                textContainerHeight = $(value).height();
                padding = (teaserHeight - textContainerHeight) / 2;
                $(value).closest('.container-wrapper').css('padding-top', padding);
            });
        }
    }

    InitSlickSliderWithVideo(slickWrapperID, slickControlsID, autoplay, autoplaySpeed) {
        $(slickWrapperID).on('init', (event, slick) => {
            $(event.currentTarget).find('.slick-next').before(slick.$dots);
            this.SetSlickPadding(event.currentTarget);
            $(event.currentTarget).show();
        });


        $(slickWrapperID).slick({
            autoplay,
            autoplaySpeed,
            dots: true,
            fade: true,
            speed: 750,
            rtl: this.IS_RTL,
            cssEase: 'linear',
            appendDots: $(slickControlsID),
            lazyLoad: 'progressive',
            pauseOnHover: true,
            pauseOnDotsHover: true,
            slide: '.slide-item',
            prevArrow: $(slickControlsID).find('.prev'),
            nextArrow: $(slickControlsID).find('.next'),
        });

        $(slickWrapperID).on('beforeChange', (event, slick, currentSlideIndex) => {
            const currentSlide = slick.$slides.get(currentSlideIndex);
            this.PauseVideo(currentSlide);
        });
        $(slickWrapperID).on('afterChange', (event) => {
            PortalImageTeaserController.PrepareVideo(event.currentTarget);
        });
    }

    static init(teaser) {
        new PortalImageTeaserController(teaser); // eslint-disable-line no-new
    }
}

window.PortalImageTeaserController = PortalImageTeaserController;
export default PortalImageTeaserController;
